import { render } from "./BaseButton.vue?vue&type=template&id=63374214"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
script.render = render

export default script